"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeRoomFieldFiltering = void 0;
var RealEstate_1 = require("../../constants/SearchPageCategories/RealEstate");
var PropertyTypes_1 = require("../../constants/SearchPageCategories/PropertyTypes");
var StructureTypes_1 = require("../../constants/SearchPageCategories/StructureTypes");
var RoomCount_1 = require("../../constants/SearchPageCategories/RoomCount");
var RoomWithPropertyType_1 = require("../../constants/SearchPageCategories/RoomWithPropertyType");
var RoomWithPropertyAndStructureType_1 = require("../../constants/SearchPageCategories/RoomWithPropertyAndStructureType");
var RentalPriceTypes_1 = require("../../constants/SearchPageCategories/RentalPriceTypes");
var makeRoomFieldFiltering = function (value, roomsQuery, currentLanguage, setRoomsQuery, structureTypeQuery, propertyTypeQuery, replacePageURL, deal, rentalPrizeQuery) {
    if (value === roomsQuery[0]) {
        setRoomsQuery([]);
        if ((propertyTypeQuery === null || propertyTypeQuery === void 0 ? void 0 : propertyTypeQuery.length) &&
            !(structureTypeQuery === null || structureTypeQuery === void 0 ? void 0 : structureTypeQuery.length) &&
            !rentalPrizeQuery.length) {
            replacePageURL(PropertyTypes_1.PROPERTY_TYPES[currentLanguage][deal][propertyTypeQuery[0]]);
        }
        if ((structureTypeQuery === null || structureTypeQuery === void 0 ? void 0 : structureTypeQuery.length) &&
            !(propertyTypeQuery === null || propertyTypeQuery === void 0 ? void 0 : propertyTypeQuery.length) &&
            !rentalPrizeQuery.length) {
            replacePageURL(StructureTypes_1.STRUCTURE_TYPES[currentLanguage][deal].new_building);
        }
        if ((propertyTypeQuery === null || propertyTypeQuery === void 0 ? void 0 : propertyTypeQuery.length) &&
            (structureTypeQuery === null || structureTypeQuery === void 0 ? void 0 : structureTypeQuery.length) &&
            !rentalPrizeQuery.length) {
            replacePageURL(StructureTypes_1.STRUCTURE_TYPES[currentLanguage][deal][propertyTypeQuery[0]]);
        }
        if (!(structureTypeQuery === null || structureTypeQuery === void 0 ? void 0 : structureTypeQuery.length) &&
            !(propertyTypeQuery === null || propertyTypeQuery === void 0 ? void 0 : propertyTypeQuery.length) &&
            !rentalPrizeQuery.length) {
            replacePageURL(RealEstate_1.REAL_ESTATE[currentLanguage].REAL_ESTATE);
        }
        if (propertyTypeQuery.length &&
            rentalPrizeQuery.length &&
            !(structureTypeQuery === null || structureTypeQuery === void 0 ? void 0 : structureTypeQuery.length)) {
            replacePageURL(RentalPriceTypes_1.RentalPriceTypes[currentLanguage].rent.WITH_PROPERTY_TYPE[propertyTypeQuery[0]]);
        }
        if (propertyTypeQuery.length &&
            rentalPrizeQuery.length &&
            (structureTypeQuery === null || structureTypeQuery === void 0 ? void 0 : structureTypeQuery.length)) {
            replacePageURL(RentalPriceTypes_1.RentalPriceTypes[currentLanguage].rent
                .WITH_PROPERTY_STRUCTURE_TYPE[propertyTypeQuery[0]]);
        }
    }
    else if (value === RoomCount_1.ROOM_COUNT.ONE ||
        value === RoomCount_1.ROOM_COUNT.TWO ||
        value === RoomCount_1.ROOM_COUNT.TREE ||
        value === RoomCount_1.ROOM_COUNT.FOUR) {
        setRoomsQuery([value]);
        if ((propertyTypeQuery === null || propertyTypeQuery === void 0 ? void 0 : propertyTypeQuery.length) &&
            !(structureTypeQuery === null || structureTypeQuery === void 0 ? void 0 : structureTypeQuery.length) &&
            !rentalPrizeQuery.length) {
            replacePageURL(RoomWithPropertyType_1.ROOM_WITH_PROPERTY_TYPE[currentLanguage][propertyTypeQuery[0]][value]);
        }
        if ((structureTypeQuery === null || structureTypeQuery === void 0 ? void 0 : structureTypeQuery.length) &&
            (propertyTypeQuery === null || propertyTypeQuery === void 0 ? void 0 : propertyTypeQuery.length) &&
            !rentalPrizeQuery.length) {
            replacePageURL(RoomWithPropertyAndStructureType_1.RoomWithPropertyAndStructureType[currentLanguage][deal][propertyTypeQuery[0]][value]);
        }
        if (propertyTypeQuery.length &&
            rentalPrizeQuery.length &&
            !(structureTypeQuery === null || structureTypeQuery === void 0 ? void 0 : structureTypeQuery.length)) {
            replacePageURL(RentalPriceTypes_1.RentalPriceTypes[currentLanguage].rent.WITH_ROOM_PROPERTY_TYPE[propertyTypeQuery[0]][value]);
        }
        if (propertyTypeQuery.length &&
            rentalPrizeQuery.length &&
            (structureTypeQuery === null || structureTypeQuery === void 0 ? void 0 : structureTypeQuery.length)) {
            replacePageURL(RentalPriceTypes_1.RentalPriceTypes[currentLanguage].rent
                .WITH_ROOM_PROPERTY_STRUCTURE_TYPE[propertyTypeQuery[0]][value]);
        }
    }
};
exports.makeRoomFieldFiltering = makeRoomFieldFiltering;
